import { BaseHttpException } from '@zaoblako/shared/common/exceptions/base-http.exception';

/** `500 - Internal Server Error` HTTP error exception class */
export class InternalServerErrorException<T = any> extends BaseHttpException<T> {
  public constructor(message?: string, options?: ErrorOptions) {
    super(500, 'InternalServerErrorException', message || 'Internal Server Error', options);
  }
}
